/**
 * Slim banner shown in the header area when the browser is offline.
 * Does not block the rest of the app.
 */
export const OfflineBanner = () => (
    <div
        className="w-full flex items-center justify-center gap-2 py-2 px-4 bg-amber-500 text-black text-sm font-medium shrink-0"
        role="alert"
        aria-live="polite"
        data-testid="offline-banner"
    >
        <span className="material-symbols-rounded !text-lg" aria-hidden>
            wifi_off
        </span>
        <span>No internet connection. Some features may be limited.</span>
    </div>
);
